import "./App.css";
import React, { useEffect, useState } from "react";
import AppRouter from "./routes/AppRouter";

function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
